import { Modal } from "tailwindcss-stimulus-components"

export default class Dialog extends Modal {
  lockScroll() {
    // Save the scroll position before we hide the scrollbar
    if (this.restoreScrollValue) {
      this.saveScrollPosition()
      // Add negative top position in order for body to stay in place
      document.body.style.top = `-${this.scrollPosition}px`
    }

    // Add right padding to the body so the page doesn't shift
    // when we disable scrolling
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
    document.body.style.paddingRight = `${scrollbarWidth}px`

    // Add classes to body to fix its position
    document.body.classList.add('fixed', 'inset-x-0', 'overflow-hidden')
  }

  unlockScroll() {
    // Remove tweaks for scrollbar
    document.body.style.paddingRight = null;

    // Remove classes from body to unfix position
    document.body.classList.remove('fixed', 'inset-x-0', 'overflow-hidden')

    // Restore the scroll position of the body before it got locked
    if (this.restoreScrollValue) {
      this.restoreScrollPosition()

      // Remove the negative top inline style from body
      document.body.style.top = null
    }
  }

  // hide modal on successful form submission
  // data-action="turbo:submit-end->dialog#submitEnd"
  submitEnd(e) {
    if (e.detail.success) {
      this.close()
    }
  }
}
